import React from "react";
import styled from "styled-components";
import "../../styles/Snapshot.scss";
import { device } from "../styles/breaks";
import { getNavigatorLanguage } from "../../services/Utils";

export const MsgHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  flex-grow: 1;
  height: ${() => window.innerHeight * 0.2}px;

  @media ${device.mobileL} {
    height: ${() => window.innerHeight * 0.2}px;
  }
`;

export const LogoWrapper = styled.div`
  width: ${(props) => props.data.width};
  height: ${(props) => props.data.height};
  align-self: center;
`;

export const LastPageLogoWrapper = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  justify-items: center;
  justify-content: center;
`;

export const LastPageLogo = styled.img`
  width: 40%;
  object-fit: scale-down;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${() => window.innerHeight * 0.5}px;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px;
  height: 60%;
`;

export const ResultImage = styled.img`
  height: 100%;
`;

export const MessageSuccess = styled.div`
  width: 100%;
  align-self: center;
  justify-self: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Success = styled.p`
  margin: 0;
  font-family: ${(props) => props.style.FontFamily};
  font-size: ${(props) => props.style.FontSize || "22px"};
  color: ${(props) => props.style.color};
  text-align: center;
  letter-spacing: ${(props) => props.style.LetterSpacing};
  font-weight: ${(props) => props.style.FontWeight};
  @media ${device.mobileXS} {
    font-size: ${(props) => (getNavigatorLanguage() !== "en" ? "1.2em" : props.style.FontSize || "22px")};
  }
  @media ${device.mobileS} {
    font-size: ${(props) => (getNavigatorLanguage() !== "en" ? "1.3em" : props.style.FontSize || "22px")};
  }
  @media ${device.mobileM} {
    font-size: ${(props) => (getNavigatorLanguage() !== "en" ? "1.5em" : props.style.FontSize || "26px")};
  }
  @media ${device.mobileL} {
    font-size: ${(props) => props.style.FontSize || "26px"};
  }
`;

export const ShowIt = styled.p`
  margin: 0;
  font-family: ${(props) => props.style.FontFamily};
  font-weight: ${(props) => props.style.FontWeight};
  font-size: ${(props) => props.style.FontSize || "20px"};
  letter-spacing: ${(props) => props.style.LetterSpacing};
  color: ${(props) => props.style.color};
  text-align: center;
  @media ${device.mobileL} {
    font-size: ${(props) => props.style.FontSize};
  }
`;

export const ResultDemoText = styled.p`
  font-weight: 390;
  line-height: 126.06%;
  margin-bottom: 15px;
  margin-top: 0;
  text-shadow: 0px 4px 40px #ffffff;
  font-family: ${(props) => props.style.FontFamily};
  font-size: ${(props) => props.style.FontSize || "24px"};
  letter-spacing: ${(props) => props.style.LetterSpacing};
  color: ${(props) => props.style.color};
  text-align: center;
  @media ${device.mobileL} {
    font-size: ${(props) => props.style.FontSize};
  }
`;

export const Qnumber = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Qnum = styled.p`
  margin: 0;
  font-family: ${(props) => props.style.FontFamily};
  font-size: 72px;
  font-weight: ${(props) => props.style.FontWeight};
  color: ${(props) => props.style.color};
  text-align: center;
  vertical-align: bottom;
  align-self: flex-end;
  width: 100%;
  @media ${device.mobileL} {
    font-size: ${(props) => props.style.FontSize};
  }
`;

export const ShareButtonWrap = styled.div`
  width: 100%;
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: -20px;
`;

export const ShareButton = styled.p`
  width: 220px;
  height: 51px;
  font-family: ${(props) => props.style.FontFamily};
  font-size: ${(props) => props.style.FontSize};
  background-color: ${(props) => props.style.BackgroundColor};
  color: ${(props) => props.style.color};
  font-weight: ${(props) => props.style.FontWeight};
  text-align: center;
  align-self: center;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-transform: uppercase;
`;

export const PrintWrap = styled.div`
  width: 100%;
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PrintButton = styled.div`
  width: 250px;
  min-height: 40px;
  height: fit-content;
  background-color: ${(props) => props.style.BackgroundColor};
  text-align: center;
  align-self: center;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border: 1px solid ${(props) => props.style.borderColor || "#DCDCDC"};
  font-family: "MuktaMedium";
  font-weight: bold;

  p {
    font-weight: ${(props) => props.style.FontWeight};
    font-family: ${(props) => props.style.FontFamily};
    color: ${(props) => props.style.color};
    font-size: ${(props) => (parseInt(props.style.FontSize.substr(0, 2)) > 14 ? `calc(${props.style.FontSize} * 0.75)` : "16px")};
  }
`;

export const DemoPrintButton = styled.p`
  width: 220px;
  height: 51px;
  font-family: MuktaRegular;
  font-size: 14px;
  letter-spacing: 0.08em;
  line-height: 17px;
  text-align: center;
  align-self: center;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-decoration-line: underline;
  margin: 5px;
  color: ${(props) => props.data.color || "#fff"};
`;

export const PrintText = styled.p`
  font-family: "MuktaRegular";
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: ${(props) => props.color};
  z-index: 22;
`;

export const SocialTab = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  flex-grow: 1;
  width: 100%;
  height: ${() => window.innerHeight * 0.3}px;
  background: ${(props) => props.background};
`;

export const GetSocialText = styled.div`
  display: flex;
  justify-content: center;
  font-family: ${(props) => props.style.FontFamily};
  font-weight: ${(props) => props.style.FontWeight};
  font-size: ${(props) => props.style.FontSize};
  color: ${(props) => props.style.color};
  width: 100%;
`;

export const FollowUS = (props) => {
  return (
    <FollowUSStyle data={props.data} onClick={props.onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 188 73.12">
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
            <g id="lVPkiB.tif">
              <path d="M94.05 0h83.42a10.3 10.3 0 016.72 2.21A9.64 9.64 0 01188 10v53.19a10 10 0 01-8 9.72 12.32 12.32 0 01-2.35.23H10.77A10.72 10.72 0 015 71.7 9.7 9.7 0 01.09 64C0 62.52 0 61 0 59.51V10.69A10.64 10.64 0 011.46 4.9 9.79 9.79 0 019 .11 18.63 18.63 0 0111.07 0h83zm0 1.18h-83.8a9.28 9.28 0 00-2 .19 8.89 8.89 0 00-7 8.71v53a9.24 9.24 0 00.18 1.73A9 9 0 0010.17 72h167.71a8.59 8.59 0 006.56-2.82 8.83 8.83 0 002.41-6.3V33.03v-22.6a8.89 8.89 0 00-1.09-4.56 8.71 8.71 0 00-8-4.63z" />
              <path d="M145.84 55.89h-15.11a6.7 6.7 0 01-1.55-.17 4.41 4.41 0 01-3.45-4.22V21.63a7 7 0 01.31-2.53 4.35 4.35 0 013.69-2.95 12.58 12.58 0 011.73-.12h29.1a8.17 8.17 0 012.15.26 4.29 4.29 0 013.19 3.49 7.5 7.5 0 01.13 1.42v29.66a5.25 5.25 0 01-.82 3 4.56 4.56 0 01-4 2h-12.92zM158 33.06a2.33 2.33 0 000 .53 11.12 11.12 0 01.09 4.34 11.18 11.18 0 01-2.1 5.28 13.31 13.31 0 01-6.9 4.68 10.86 10.86 0 01-5.54.31 13.12 13.12 0 01-7-4 11.09 11.09 0 01-2.98-9.2c0-.42.11-.83.15-1.24a5.55 5.55 0 000-.69h-2.63c-.36 0-.47.13-.52.5a4 4 0 000 .49v15.76a1.36 1.36 0 001.43 1.39h27.73a1.4 1.4 0 001.45-1.47V33.73c0-.66-.07-.71-.71-.71h-1.81a1.94 1.94 0 00-.66.04zM138.24 36a7.63 7.63 0 0015.25 0 7.7 7.7 0 00-7.64-7.6 7.58 7.58 0 00-7.61 7.6zm19.24-15.2h-2.25a1.39 1.39 0 00-1.56 1.48v4.49a1.38 1.38 0 001.5 1.48h4.62a1.31 1.31 0 001.41-1.46v-4.5a1.34 1.34 0 00-1.48-1.47c-.72-.04-1.5-.02-2.24-.02zM64.49 41.17c.26-.65.78-.68 1.31-.56 1 .23 1.41.24 1.38 1.64 0 1.93-.08 3.87-.07 5.8a12.81 12.81 0 00.23 1.85 1.53 1.53 0 00.14.41.74.74 0 001.32.17 2.38 2.38 0 00.62-1.54v-1.49a9.69 9.69 0 01.95-5 5.54 5.54 0 01.85-1.29 2.83 2.83 0 014.07-.35l.31.24h.11c.27-.17.43-.55.82-.49a7.72 7.72 0 011.44.33.74.74 0 01.42.78v7.23c.16-.2.25-.28.31-.38a19.44 19.44 0 002-4.27 1.39 1.39 0 00-.19-1.46 1.75 1.75 0 010-2 1.63 1.63 0 011.44-.95A1.16 1.16 0 0183.28 41c0 .18 0 .36.06.63l1.37-.21 1-.17a1.3 1.3 0 011.55 1.58c-.11.66-.26 1.31-.4 2a11.12 11.12 0 00-.31 3.09 11.69 11.69 0 00.3 1.85c.16.65.53 1 1 1a1.17 1.17 0 001.15-.99 2.33 2.33 0 00.09-1 11.58 11.58 0 01.55-5.78 5.62 5.62 0 011.23-2A2.87 2.87 0 0195 41l.14.11h.12c.23-.25.43-.51.82-.5a2.35 2.35 0 011.48.39 1.1 1.1 0 01.38.95c0 .81 0 1.62-.07 2.43a31.2 31.2 0 00.13 4.89 4 4 0 00.17.85c.11.32.26.63.65.69a.84.84 0 00.83-.44 4.62 4.62 0 001-2.89v-5.81a5.29 5.29 0 01.06-.8.44.44 0 01.52-.42 8.63 8.63 0 011.35.21.89.89 0 01.63 1v2.43a.86.86 0 00.11.48c.06-.17.13-.33.19-.5.31-.86.6-1.73.94-2.57s.69-1.11 1.54-1a1.8 1.8 0 011.71 1.47c.08.72.09 1.45.12 2.18a15.43 15.43 0 00.18 2.13 1.78 1.78 0 00.12-.29 30.83 30.83 0 011.37-4.41.36.36 0 010-.11c.41-1 .88-1.17 1.88-.86 1.42.42 1.7.8 1.67 2.28 0 1.2-.11 2.41-.1 3.62a23.87 23.87 0 00.24 2.79 2.83 2.83 0 00.41 1.09.59.59 0 001.1 0 7.35 7.35 0 00.52-1.33c.08-.23.11-.48.19-.72a.48.48 0 01.53-.35.43.43 0 01.41.46 4.48 4.48 0 01-1.19 3.44 2.28 2.28 0 01-3.21-.1 4 4 0 01-1.2-2.61c-.14-1.45-.17-2.9-.24-4.36v-.71h-.15a10.77 10.77 0 00-.44 1.06 18.74 18.74 0 00-1.05 5.49c0 .74-.2.92-.93 1a1.63 1.63 0 01-1.81-1.36c-.17-.88-.3-1.76-.39-2.65-.11-1.2-.16-2.41-.24-3.61a1.2 1.2 0 00-.11-.19c-.14.25-.28.44-.37.65a14.09 14.09 0 00-1.19 4.5c-.07.83-.08 1.66-.11 2.49s-.13.82-.82.93a2.67 2.67 0 01-.56.06c-.94 0-1.44-.24-1.62-1.2a.44.44 0 00-.1-.15c-1.85 2-3.27 1.82-4.78-.69-.11.13-.23.24-.32.36a3.8 3.8 0 01-2.75 1.66 2.87 2.87 0 01-2.6-1.07l-.41-.49c-.16.21-.27.35-.39.49a2.48 2.48 0 01-3.91.3 4.48 4.48 0 01-1.31-2.83 12.79 12.79 0 01.2-4.09c.07-.43.13-.85.19-1.29a2.26 2.26 0 00-1.46.07c-.3.09-.37.36-.48.61-.58 1.22-1.11 2.47-1.78 3.64a31.44 31.44 0 01-2.07 3 1.76 1.76 0 00-.4 1.14v3.56a8.93 8.93 0 01-.63 3.1 3.86 3.86 0 01-3.77 2.55 4.44 4.44 0 01-1.6-.44A2.72 2.72 0 0171 57.28a6.47 6.47 0 011.76-2.61c.85-.85 1.76-1.65 2.64-2.48a1.15 1.15 0 00.45-1.19l-.46.36a4.1 4.1 0 01-1.65 1 3 3 0 01-3.16-.95c-.17-.18-.32-.37-.52-.62l-.41.58a2.48 2.48 0 01-3.66.55 3.55 3.55 0 01-.66-.82c-.11-.16-.18-.36-.32-.63l-.47.56a4 4 0 01-2.22 1.41 2.93 2.93 0 01-3.11-1.22c-.29-.42-.52-.89-.81-1.39-.12.19-.22.36-.34.52-.33.46-.64.93-1 1.35a2.39 2.39 0 01-3.73-.31 5.84 5.84 0 01-.9-2.24c0-.2-.08-.4-.15-.71l-.5.9a5.79 5.79 0 01-3.53 3 5.73 5.73 0 01-4.18-.43.83.83 0 01-.5-1.17 2.27 2.27 0 01.35-.65c.48-.61.79-.64 1.43-.21a5.47 5.47 0 00.8.48 1.09 1.09 0 001.69-.9 2.37 2.37 0 00-.37-1.72 10.78 10.78 0 00-2-2c-.17.23-.32.41-.45.61-.77 1.26-1.52 2.53-2.3 3.79a6.77 6.77 0 01-.85 1.07 6.32 6.32 0 01-1.2 1 1.59 1.59 0 01-2.59-1 10.69 10.69 0 01-.33-3.65c.05-1.39.11-2.78.16-4.18v-.69c-.27.3-.46.47-.61.68a14.73 14.73 0 00-2.3 4.82c-.31 1.12-.53 2.27-.77 3.4-.14.66-.26.82-.93.86a1.33 1.33 0 01-1.64-1.16 4.92 4.92 0 01-.09-.86v-9a3.17 3.17 0 010-.44.65.65 0 01.88-.61c.2 0 .41.08.61.13.77.21 1 .43 1 1.21 0 1.13 0 2.25.06 3.37a1.54 1.54 0 00.12.71c.07-.15.14-.3.2-.45.35-.85.67-1.71 1.06-2.53a5.3 5.3 0 011.5-1.9 2.17 2.17 0 012.51-.18 2 2 0 011.23 2c-.06 2-.08 4-.11 6a2.63 2.63 0 00.09.74A2.55 2.55 0 0041 50a2.41 2.41 0 001-1.06c.78-1.28 1.52-2.58 2.27-3.87a.72.72 0 00-.06-.87c-1-1.35.19-3.6 1.76-3.93a3.14 3.14 0 011.06 0 1 1 0 01.87 1.23 3.8 3.8 0 01-.63 1.61l-.31.47c-.24.37-.22.51.14.78s1 .77 1.55 1.16a4.38 4.38 0 011.55 1.76 14.36 14.36 0 01.46 1.62 5.31 5.31 0 001.47-2.47 5.17 5.17 0 00.12-1.11v-4.56c0-.67 0-.69-.72-.7H50.1c-.65 0-.83-.28-.79-.93s.43-1.13 1.2-1.13c.37 0 .75 0 1.12.06.66 0 .9-.2.9-.87v-2.06c0-.69.29-.94 1-.87a7.84 7.84 0 011.15.24.84.84 0 01.67.8V37.23c0 .69.21.87.91.9s1.33.07 2 .13.73.29.64.83c-.11.73-.36 1-1.13 1h-2c-.46 0-.57.09-.58.54-.05 2.58-.11 5.16-.12 7.74a4.62 4.62 0 00.29 1.46c.26.77.64.85 1.24.31a4.87 4.87 0 001.51-3.38 20.23 20.23 0 01.4-2.9 5.53 5.53 0 011.35-2.56 4.26 4.26 0 011-.79 2.46 2.46 0 012.55 0c.35.17.67.4 1.08.66zm.16 4.48v-.68A4.92 4.92 0 0064.2 43a1.26 1.26 0 00-2.2-.26 3.81 3.81 0 00-.64 1.26 10 10 0 00-.36 4.28 6.62 6.62 0 00.42 1.72 1.15 1.15 0 002 .3 3.64 3.64 0 00.35-.52 8.4 8.4 0 00.88-4.13zm11.25-.1c0-.41-.06-1-.15-1.57a3.25 3.25 0 00-.32-1 1.2 1.2 0 00-1.94-.38 2.8 2.8 0 00-.79 1.18 9.65 9.65 0 00-.58 3.22 7.14 7.14 0 00.51 2.93 1.18 1.18 0 002.1.3 3.48 3.48 0 00.43-.75 10.59 10.59 0 00.74-3.93zm15.93 1.32a8.34 8.34 0 000 1.12 13.24 13.24 0 00.37 1.77 1.16 1.16 0 00.94 1A1.25 1.25 0 0094.5 50a6.65 6.65 0 00.55-1.18 11.21 11.21 0 00.28-4.75A3.29 3.29 0 0095 43a1.25 1.25 0 00-2.16-.25A3.88 3.88 0 0092.2 44a8 8 0 00-.37 2.87zm-16 7l-.85.9a11.4 11.4 0 00-1.73 2.35 2.9 2.9 0 00-.36 1.68 1.15 1.15 0 001.56 1 1.87 1.87 0 001.16-1.37 10.58 10.58 0 00.39-4.14 2.47 2.47 0 00-.13-.38zM26.78 36.07a3.47 3.47 0 00-.45.39 7.64 7.64 0 00-1.78 6.33 6.71 6.71 0 00.5 1.33c.07.17.2.33.25.5a.38.38 0 01-.35.53 1.44 1.44 0 01-.54-.1 3.85 3.85 0 01-2.31-4.41 8.94 8.94 0 014.22-6 2.48 2.48 0 012.55-.08 1.06 1.06 0 01.64.86 8.26 8.26 0 01.08 1q0 6.64-.08 13.29a6.46 6.46 0 01-1 3.44 3.41 3.41 0 01-1.62 1.4c-.22.08-.47.19-.63 0a.73.73 0 01-.05-.58 17.73 17.73 0 00.6-5.37V36.74c.01-.19-.01-.37-.03-.67zM68.6 23.89c-.37 1.08-.75 2.16-1.12 3.23l-.09.3a.77.77 0 01-.76.62c-.4 0-.59-.11-.77-.58s-.37-1-.54-1.52c-.47-1.34-.93-2.67-1.39-4-.11-.32 0-.46.29-.56a.79.79 0 011.14.61c.36 1.13.71 2.26 1.07 3.39 0 .13.11.25.2.48.11-.23.19-.37.24-.51.34-1 .67-2 1-3 0-.16.11-.31.17-.47a.66.66 0 01.68-.45.7.7 0 01.67.47c.07.19.13.39.2.59.32 1 .65 2 1 3 0 .11.1.22.19.43a5.18 5.18 0 00.24-.5c.35-1.1.72-2.21 1-3.33a.78.78 0 01.73-.62c.63-.07.81.14.6.74l-1.76 5.07c0 .1-.07.19-.1.29a.71.71 0 01-.75.54c-.39 0-.57-.11-.72-.55-.27-.74-.52-1.49-.78-2.23-.16-.47-.33-.93-.5-1.39zM105.41 25.38v-1.86-1.56c0-.56.18-.58.55-.61.53-.05.72.12.73.66v5.18c0 .25.11.55-.18.67a1 1 0 01-1-.08 3.07 3.07 0 01-.41-.47l-2.54-3.25c-.07-.09-.16-.18-.31-.35 0 .25-.06.4-.06.55v3c0 .53-.2.75-.61.77a.58.58 0 01-.68-.56 4.21 4.21 0 010-.5v-4.81c0-.26-.08-.56.25-.71a.93.93 0 011 .07 2 2 0 01.42.44l2.43 3.21a1.54 1.54 0 00.26.25zM37.66 24.7a3.45 3.45 0 113.41 3.44 3.3 3.3 0 01-3.41-3.44zm5.55 0v-.27a2.13 2.13 0 00-1.61-1.85 2 2 0 00-2.33 1.13 2.34 2.34 0 00.2 2.38 2.08 2.08 0 002.25.79 2.21 2.21 0 001.49-2.2zM60 21.34a3.26 3.26 0 013.42 3.33A3.35 3.35 0 0160 28.12a3.39 3.39 0 110-6.78zm2 3.44a2.11 2.11 0 00-1.83-2.23 2.06 2.06 0 00-2.33 1.82A2.24 2.24 0 0059.8 27a2.1 2.1 0 002.25-2.22zM92.75 24.72a3.46 3.46 0 113.43 3.42 3.28 3.28 0 01-3.43-3.42zm5.5-.28A2 2 0 0097 22.69a2 2 0 00-2.73 1.13 2.29 2.29 0 001.14 3c1.4.58 2.86-.48 2.84-2.38zM77.27 23.79v-1.75a.64.64 0 011-.56.68.68 0 01.23.46 8.61 8.61 0 010 .88v2.68a1.48 1.48 0 002.19 1.3 1.22 1.22 0 00.75-.87 5.35 5.35 0 00.11-1v-2.87c0-.5.22-.7.67-.69a.57.57 0 01.62.57v3.37a2.71 2.71 0 01-3.54 2.74 2.28 2.28 0 01-2-2.17 6 6 0 010-.74v-1.37zM86.52 21.35a3.66 3.66 0 011.89.54c.36.24.4.4.21.71-.29.47-.46.57-.84.36a2.43 2.43 0 00-1.54-.41 1.33 1.33 0 00-.52.17.61.61 0 000 1 3.71 3.71 0 00.8.32c.45.16.92.27 1.35.46A1.56 1.56 0 0189 26.25 1.78 1.78 0 0187.71 28a3.88 3.88 0 01-3.34-.49.62.62 0 01.1-1.16c.23-.11.39 0 .56.16a2.51 2.51 0 001.82.49 1.18 1.18 0 00.46-.14.63.63 0 000-1.14 8.11 8.11 0 00-1.18-.38c-.33-.11-.68-.2-1-.34a1.64 1.64 0 01-1-1.52 1.8 1.8 0 01.87-1.71 3.17 3.17 0 011.52-.42zM34.41 21.46h1.81c.53 0 .68.13.68.58s-.16.62-.71.63h-2.25c-.68 0-.71 0-.7.7 0 1 0 1 1 1h1.62c.5 0 .66.15.66.53s-.19.56-.7.56h-1.91c-.57 0-.65.08-.66.64v1.18c0 .65-.14.81-.66.8s-.65-.16-.65-.83v-2.81-2.3c0-.55.12-.65.68-.65h1.81zM52.76 24.18v1.93c0 .64.11.73.72.73h2.06c.48 0 .67.19.66.61s-.2.58-.65.58h-3.43c-.5 0-.66-.18-.66-.7v-5.17c0-.53.12-.67.48-.75a.61.61 0 01.82.59v2.18zM45.78 24.69v-2.61c0-.47.19-.66.63-.68a.5.5 0 01.6.54v4.43c0 .37.12.47.5.48h2.25c.42 0 .61.17.67.51a.52.52 0 01-.52.68H46.3c-.41 0-.53-.15-.54-.6.01-.92.02-1.83.02-2.75z" />
            </g>
          </g>
        </g>
      </svg>
    </FollowUSStyle>
  );
};

export const FollowUSStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  align-self: center;
  margin: 12px auto;
  svg {
    fill: ${(props) => props.data.color};
  }
`;

const PoweredByStyle = styled.div`
  justify-content: center;
  width: 100%;
  z-index: 25;
  align-self: center;
  width: 25%;
`;
// todo(vmyshko): duplicate, reuse webapp/src/components/styles/IntroStyle.js
export function PoweredByOld({ data }) {
  const { location, ...style } = data;

  return (
    <PoweredByStyle style={style}>
      {data.location ? (
        <img style={style} src={data.location} alt={'Location'} />
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.56 23">
          <g>
            <path
              fill="currentColor"
              d="M13.71 0h-6a5.44 5.44 0 00-1 .08A8 8 0 002 2.79a7.78 7.78 0 00-2 4.95v5.46a14.4 14.4 0 00.12 1.86 8 8 0 009.28 6.48 7.86 7.86 0 006.26-5.38.71.71 0 01.52-.5 8.06 8.06 0 005.47-6.94 7.61 7.61 0 00-1.36-5.19A7.79 7.79 0 0013.71 0zM16 14.14a8 8 0 01-1.27.36.3.3 0 00-.27.28A6.47 6.47 0 0111 19.52a6.54 6.54 0 01-9.37-4.73 21 21 0 01-.12-2.39v-1.59-2.79a6.63 6.63 0 015.56-6.49 6.2 6.2 0 011-.07h5.61A6.57 6.57 0 0116 14.14zM41.11 9.05A3.66 3.66 0 0037.39 6h-4.08c-.5 0-.61.1-.61.59V17.1c0 .81 0 .81.79.81.5 0 .6-.1.6-.6v-3.76c0-.19 0-.28.26-.27H37a.41.41 0 01.43.27c.59 1.18 1.17 2.36 1.77 3.54.5 1 .22.8 1.33.81.52 0 .65-.2.4-.67-.72-1.36-1.46-2.72-2.2-4.09.28-.17.56-.3.8-.47a3.53 3.53 0 001.58-3.62zm-3.35 3a4.72 4.72 0 01-.64 0h-2.65c-.28 0-.39-.06-.38-.37v-2-2.12c0-.21.06-.29.29-.28h3.08a2.38 2.38 0 01.3 4.72zM56 11.5l-.13.05c-.09-.24-.14-.46-.45-.48-.49 0-.67.12-.67.61v10.59c0 .64.1.74.73.73.39 0 .53-.14.53-.53v-4.89l.22.12a3.17 3.17 0 004-.74 3.72 3.72 0 00.77-3.53 3.15 3.15 0 00-5-1.93zm3.36 4.5a2.24 2.24 0 01-3.18.35.45.45 0 01-.12-.3v-1.53-1.49a.67.67 0 01.13-.34 2.05 2.05 0 013.45.66 2.66 2.66 0 01-.28 2.65zM49 11a6.94 6.94 0 00-1.25.5c-.07-.38-.29-.46-.72-.39s-.36.17-.36.59v10.72c0 .47.12.58.63.58s.62-.11.62-.59V17.6a1.48 1.48 0 01.25.12 3.25 3.25 0 003.64-.44 3.89 3.89 0 00.42-5.08A3 3 0 0049 11zm1 5.82a2.38 2.38 0 01-2-.44.38.38 0 01-.12-.27v-3.08a.53.53 0 01.17-.34 2.06 2.06 0 013.54 1.11c0 .22.06.46.09.69A2.24 2.24 0 0150 16.83zM67.57 11.45a3.74 3.74 0 00-1.42 3.92 3.26 3.26 0 001.35 2.12 3.77 3.77 0 004.13 0c.58-.31.58-.39.18-.92-.23-.31-.28-.32-.62-.12a3.26 3.26 0 01-1.75.49 2.34 2.34 0 01-2.1-1.86 2 2 0 010-.25H72c.41 0 .55-.13.54-.55a4.22 4.22 0 00-.09-1.07 3.14 3.14 0 00-4.88-1.76zm-.21 2.34a2 2 0 012-1.77 1.83 1.83 0 011.84 1.77zM77.72 14.6c-.44-.29-.93-.53-1.4-.79a7.83 7.83 0 01-1-.59.62.62 0 01.21-1.11 1.27 1.27 0 01.61 0c.38.08.75.23 1.14.35.12 0 .33.08.37 0a2 2 0 00.39-.66c.07-.23-.14-.36-.33-.46A3.81 3.81 0 0076 10.9a6.15 6.15 0 00-.75.1 1.74 1.74 0 00-.86 3 5.63 5.63 0 001 .75c.47.29 1 .53 1.45.83a.74.74 0 01.33.84.8.8 0 01-.71.57 2.48 2.48 0 01-1.82-.48c-.29-.2-.44-.2-.6 0-.3.44-.32.66 0 .87a3.29 3.29 0 003.14.51 1.88 1.88 0 001.33-1.51 1.72 1.72 0 00-.79-1.78zM64.21 6.5A.44.44 0 0064 6c-.57-.26-1 0-1 .62v10.6c0 .63 0 .69.68.69s.57-.08.57-.59V6.5zM44.18 11.2a2.34 2.34 0 00-.87-.07c-.26 0-.25.3-.25.52V17.43c0 .36.13.47.48.47h.23c.43 0 .54-.11.54-.54v-2.87-2.9c-.01-.14-.06-.37-.13-.39zM43.66 6.35a.85.85 0 00-.84.84.87.87 0 00.84.84.84.84 0 00.83-.85.8.8 0 00-.83-.83z"
            />
            <path
              fill="currentColor"
              d="M13.62 2.77H8.07a5 5 0 00-1.16.13 5.25 5.25 0 00-4.14 5.25v5.41A5.23 5.23 0 003 14.92a5 5 0 004.14 3.88 5 5 0 005.06-2 4.89 4.89 0 001.08-3.19c0-.3.12-.39.39-.38a5.54 5.54 0 00.71 0 5.26 5.26 0 00-.76-10.47zm.07 9h-1.52c-.27 0-.37.07-.36.35v1.61a3.82 3.82 0 01-3.39 3.67 3.75 3.75 0 01-4.1-3 8.79 8.79 0 01-.09-1.26v-5a3.91 3.91 0 014-3.91h5.34a3.79 3.79 0 01.09 7.57z"
            />
          </g>
        </svg>
      )}
    </PoweredByStyle>
  );
}
